import { render, staticRenderFns } from "./AddFiles.vue?vue&type=template&id=09d0a6b1&scoped=true"
import script from "./AddFiles.vue?vue&type=script&lang=js"
export * from "./AddFiles.vue?vue&type=script&lang=js"
import style0 from "./AddFiles.vue?vue&type=style&index=0&id=09d0a6b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d0a6b1",
  null
  
)

export default component.exports